export default {
  coachRating: 'coachRating',
  version: 'v1'
};

export const defaults = {
  type: 'defaultFeedback',
  version: 'v1'
};
